export const APP_VERSION = process.env.REACT_APP_VERSION || 'unknown';
export const PROMPT_VERSION = process.env.REACT_APP_PROMPT_VERSION || 'unknown';
